import React, { useContext, useEffect, useState } from "react";
import useGetCategoryKeys from "../../api/categoryKeys";
import { Link } from "react-router-dom";

import './categories-right-panel.styles.scss';



export default function CategoriesRightPanel({category}) {
    const getCategoryKeys = useGetCategoryKeys();
    const [categoryKeys, setCategoryKeys] = useState([]);
    const [showSave, setShowSave] = useState(false);

    useEffect(() => {
        (async () => {
            const categoryKeys = await getCategoryKeys(category.id);
            setCategoryKeys(categoryKeys)
        })();
    }, [category]);

    return (
        <div className="d-flex flex-column col-6">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h6>Translation Keys for category: {category.name}</h6>
            </div>
            <div className="category-column">
                {categoryKeys.map((categoryKey, index) => (
                    <Link
                        to={{ pathname: `/keys`, search: `?key=${categoryKey.text}` }}
                        data-position={index}
                        draggable="true"
                        className={'category-translation-key key-item d-flex align-items-center justify-content-between p-3 mb-2 text-decoration-none'}
                        key={index}>
                            <div className="d-flex flex-column">
                                <span className={"translation-key"}>{categoryKey.text}</span>
                                <span className="translation-source">{categoryKey.english_text}</span>
                            </div>
                    </Link>
                ))}
            </div>

        </div>
    )
}